import { idleCallbackPromise } from '@/utils/helpers'

export function detectAdBlock(onBlocked: () => void, onSuccess?: () => void) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '/common_ad.js'
    script.async = true
    script.onerror = onBlocked
    script.onload = () => {
        onSuccess?.()
    }

    idleCallbackPromise().then(() => document.head.appendChild(script))
}
